import { IItemInterface } from "./dataInterface"


const ImageHost = "https://static.enjoysushi.es/";

export interface IItemPostreInterface extends IItemInterface {
    precio: number;
}

export const postre: IItemPostreInterface[] = 
[
    {
        'indicator': 400,
        'name': 'Coulant de chocolate',
        'description': '',
        'image': ImageHost + 'assert/postre/coulant-choco.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 4.50
    },
    {
        'indicator': 401,
        'name': 'Copa de fresa',
        'description': '',
        'image': ImageHost + 'assert/postre/copa-fresa.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 4.50
    },
    {
        'indicator': 402,
        'name': 'Makis de helado',
        'description': '',
        'image': ImageHost + 'assert/postre/makis-helado.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 5.00
    },
    {
        'indicator': 403,
        'name': 'Trufa Té',
        'description': '',
        'image': ImageHost + 'assert/postre/trufa-te.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 4.50
    },  
    {
        'indicator': 404,
        'name': 'Copa con Nata y Nueces',
        'description': '',
        'image': ImageHost + 'assert/postre/copa-nata-nueces.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 4.50
    },
    {
        'indicator': 405,
        'name': 'Copa Baileys',
        'description': '',
        'image': ImageHost + 'assert/postre/copa-bailey.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 4.50
    },      
    {
        'indicator': 406,
        'name': 'Helado Almendrado',
        'description': '',
        'image': ImageHost + 'assert/postre/helado-almendrado.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 3.20
    },
    {
        'indicator': 407,
        'name': 'Tiramisú',
        'description': '',
        'image': ImageHost + 'assert/postre/tiramisu.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 4.50
    },
                          
]